/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_Save_AsInputs */



/**
* | output |
* | --- |
* | "Save/Save As Project" |
*
* @param {Save_Save_AsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_save_as = /** @type {((inputs?: Save_Save_AsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Save_AsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer/Enregistrer sous le projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichern/Speichern unter Projekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva/Salva come progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить/Сохранить как проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar/Guardar como proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存/另存为项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存/名前を付けてプロジェクトを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सहेजें/इस रूप में सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar/Salvar como projeto")
	return /** @type {LocalizedString} */ ("Save/Save As Project")
});